function getTitle(vm) {
    const { title } = vm.$options
    if (title) {
        return typeof title === 'function'
            ? title(vm)
            : title
    }
}

export default {
    created() {
        const title = getTitle(this)
        if (title) {
            document.title = 'OneTrack - ' + title
        }
    }
}